var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirac(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M27.63,1.27a22,22,0,0,0,1.92,13.09A32.86,32.86,0,0,0,15.63,1H1V63H1A32.64,32.64,0,0,0,29.74,45.82,38.24,38.24,0,0,0,26,62.9,31,31,0,0,0,27.63,1.26Zm2.73,43.35a32.79,32.79,0,0,0-.14-29,21.86,21.86,0,0,0,19,11,21.8,21.8,0,0,0,4.34-.43A37.21,37.21,0,0,0,30.36,44.62Zm84.18-7.12h5.92l5.36,10.11h6.34l-6-11.4a10.45,10.45,0,0,0-5-19.6H108.7v31h5.84Zm11-10.45a4.64,4.64,0,0,1-4.52,4.77h-6.52V22.28H121a4.65,4.65,0,0,1,4.6,4.7Zm18.85-10.44-10.6,31H140l2.32-7.17H153.8l2.33,7.17h6.12l-10.58-31ZM144.05,35l4-12.29L152,35Zm42.42,2.53L191,41.23A15.85,15.85,0,1,1,191,23l-4.53,3.71a9.79,9.79,0,0,0-18.11,5.42,9.79,9.79,0,0,0,9.75,10A9.91,9.91,0,0,0,186.47,37.52Zm-93.6-5.41A15.48,15.48,0,0,0,77.4,16.61H66.14v31H77.39A15.49,15.49,0,0,0,92.87,32.12ZM72,42V22.25h5.35a9.61,9.61,0,0,1,9.52,9.84,9.62,9.62,0,0,1-9.52,9.85ZM97.12,16.61H103v31H97.12Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirac);
export default __webpack_public_path__ + "static/media/dirac.84fc87e7487067984dc2c4bb3adcc591.svg";
export { ForwardRef as ReactComponent };